<template>
  <el-dialog
    class="data-migration-task-details-dialog common-dialog"
    :close-on-click-modal="false"
    title="任务详情"
    :visible.sync="dialogVisible"
  >
    <el-descriptions title="任务信息" :border="true">
      <el-descriptions-item label="任务名称">{{
        detailsData.task?.task_name || $constants.EMPTY
      }}</el-descriptions-item>
      <el-descriptions-item label="迁移类型">{{ detailsData.task | transMigrationType($constants.EMPTY)}}</el-descriptions-item>
      <el-descriptions-item label="任务ID">{{
        detailsData.task?.task_id || $constants.EMPTY
      }}</el-descriptions-item>
      <el-descriptions-item label="迁移高度">{{
        detailsData.task?.transfer_height || $constants.EMPTY
      }}</el-descriptions-item>
    </el-descriptions>

    <el-descriptions title="链信息" :border="true">
      <el-descriptions-item label="链ID">{{
        detailsData.org_id || $constants.EMPTY
      }}</el-descriptions-item>
      <el-descriptions-item label="用户名称">{{
        detailsData.user_name || $constants.EMPTY
      }}</el-descriptions-item>
      <el-descriptions-item label="用户证书">
        <el-link :href="detailsData.origin_cert_path" download>下载</el-link>
      </el-descriptions-item>
      <el-descriptions-item label="config文件">
        <el-link :href="detailsData.origin_sdk_path" download>下载</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions title="Chainmaker链信息" :border="true" >
      <el-descriptions-item label="类型">{{ detailsData.key_type || $constants.EMPTY }}</el-descriptions-item>
      <el-descriptions-item label="组织证书与配置文件">
        <el-link :href="detailsData.target_config_path" download>下载</el-link>
      </el-descriptions-item>
    </el-descriptions>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
// import downloadFile from '@/utils/downloadFile'
// import { downloadFile } from '@/utils/downloadFile';

export default {
  name: 'TaskDetailsInfo',
  filters: {
    transMigrationType: function(value, defaultValue) {
      if(value && value.origin_chain_type && value.origin_chain_version && value.target_chain_type && value.target_chain_version) {
        return `${value.origin_chain_type} ${value.origin_chain_version} ${ value.target_chain_type} ${value.target_chain_version}`;
      } else {
        return defaultValue;
      }
    }
  },
  data() {
    return {
      title: '详情',
      loadingBtn: false,
      dialogVisible: false,
      data: {},
      detailsData: {}
    }
  },
  methods: {
    getData(serviceAddress) {
      let url = `${serviceAddress}/transfer/task_info/${this.data.task_id}`

      this.$apis.datamigration.taskDetails(url).then(res => {
        if (res.code != 200) {
          this.$message.error(res.message)
        } else {
          this.detailsData = res.result
          this.$message.success('获取详情成功...')
        }

        return
      })
    },
    removeDomain(index) {
      this.serverDateForm.domains.splice(index, 1)
    },
    handleCancel() {
      this.dialogVisible = false
    },
    onDownload(url) {
      let urlStr = window.VUE_APP_API_HOST + '/transfer/download?' + `filename=${url}`
      downloadFile({ file_url: urlStr, file_name: '' })
    },
    handleOpen(data, serviceAddress) {
      this.data = data
      this.getData(serviceAddress)
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.data-migration-task-details-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-descriptions {
    margin-bottom: var(--base-size-24);
  }
}
</style>
